import * as React from 'react';
import { IConfig } from './types/Config.Type';
import { ILoaderProps } from './map/layer/ILoaderProps';
import { RaftAquacultureNorth } from './map/layers/vietnam/RaftAquacultureNorth';
import { RaftAquacultureCentral } from './map/layers/vietnam/RaftAquacultureCentral';
import { RopeAquacultureNorth } from './map/layers/vietnam/RopeAquacultureNorth';
import { RopeAquacultureCentral } from './map/layers/vietnam/RopeAquacultureCentral';
import { WaterQualityNorth } from './map/layers/vietnam/WaterQualityNorth';
import { WaterQualityCentral } from './map/layers/vietnam/WaterQualityCentral';
import { SocioeconomicNorth } from './map/layers/vietnam/SocioeconomicNorth';
import { SocioeconomicCentral } from './map/layers/vietnam/SocioeconomicCentral';
import { HydrodynamicNorth } from './map/layers/vietnam/HydrodynamicNorth';
import { HydrodynamicCentral } from './map/layers/vietnam/HydrodynamicCentral';
import { UrbanAreasNorth } from './map/layers/vietnam/UrbanAreasNorth';
import { UrbanAreasCentral } from './map/layers/vietnam/UrbanAreasCentral';
import { PortsNorth } from './map/layers/vietnam/PortsNorth';
import { PortsCentral } from './map/layers/vietnam/PortsCentral';
import { RoadsNorth } from './map/layers/vietnam/RoadsNorth';
import { RoadsCentral } from './map/layers/vietnam/RoadsCentral';

const Config: IConfig = {
  map: {
    mapKey: "pk.eyJ1IjoibG9uZ2xpbmVlbnZpcm9ubWVudCIsImEiOiJjbGF0cHF1ZWUwM2l0M3FwcDcyN3B1YXpmIn0.snFi9yTPEZ5lfQxE3h3Epg",
    greyStyle: null, // "mapbox://styles/longlineenvironment/clatpsjsl003r15okdwsdclmi",
    satelliteStyle: "mapbox://styles/longlineenvironment/clnkins3a001s01qw9k3efaj5/draft",
    longitude: 107.997,
    latitude: 16.25791,  
    zoom: 5, 
    minZoom: 0,
    maxZoom: 14,
    bearing: 0,
    pitch: 0,
    max_bounds: [
      [107.997 - 20,  16.25791 - 15],    // Southwest (lng/lat)
      [107.997 + 20,  16.25791 + 15]     // Northeast (lng/lat)
    ]
  },
  UI: {
    height: 75,
    before_layer: 'waterway-label',
    large_screen: 900,
    load_delay_base: 0,
    load_delay_random: 0,
  },

  legend_caption: "Suitability",
  suitability: [
    { name: 'Spatial constraints', color: '#aaaaaa', hidden: true },
    { name: 'Not suitable', color: '#e31a1c' },
    { name: 'Moderately suitable', color: '#ff8000' },
    { name: 'Suitable', color: '#0cf600' },
    { name: 'Highly suitable', color: '#128800' },
  ],  

  datasets: [
    // ATLAS GROUP
    {
      key: 'raft_aquaculture_north',
      ids: [ 'raft_aquaculture_north' ],
      title: 'Raft aquaculture north Vietnam',
      description: 'Seaweed raft aquaculture suitability in north Vietnam',
      group: 'atlas',
      active: true,
      renderer: (p: ILoaderProps) => <RaftAquacultureNorth {...p}/>
    }, {
      key: 'raft_aquaculture_central',
      ids: [ 'raft_aquaculture_central' ],
      title: 'Raft aquaculture central Vietnam',
      description: 'Seaweed raft aquaculture suitability in central Vietnam',
      group: 'atlas',
      active: false,
      renderer: (p: ILoaderProps) => <RaftAquacultureCentral {...p}/>
    }, {
      key: 'rope_aquaculture_north',
      ids: [ 'rope_aquaculture_north' ],
      title: 'Rope aquaculture north Vietnam',
      description: 'Seaweed rope aquaculture suitability in north Vietnam',
      group: 'atlas',
      active: false,
      renderer: (p: ILoaderProps) => <RopeAquacultureNorth {...p}/>
    }, {
      key: 'rope_aquaculture_central',
      ids: [ 'rope_aquaculture_central' ],
      title: 'Rope aquaculture central Vietnam',
      description: 'Seaweed rope aquaculture suitability in central Vietnam',
      group: 'atlas',
      active: false,
      renderer: (p: ILoaderProps) => <RopeAquacultureCentral {...p}/>
    },  
    // INFRASTRUCTURE GROUP
    // roads north
    // roads central
    // urban areas north
    // urban areas central
    // ports north vietnam
    // ports central vietnam
    {
      key: 'urban_north',
      ids: [ 'urban_north' ],
      title: 'Urban areas north Vietnam',
      description: 'Built-in areas in north Vietnam',
      group: 'infrastructure',
      active: false,
      renderer: (p: ILoaderProps) => <UrbanAreasNorth {...p}/>
    }, {
      key: 'urban_central',
      ids: [ 'urban_central' ],
      title: 'Urban areas central Vietnam',
      description: 'Built-in areas in central Vietnam',
      group: 'infrastructure',
      active: false,
      renderer: (p: ILoaderProps) => <UrbanAreasCentral {...p}/>
    }, {
      key: 'ports_north',
      ids: [ 'ports_north', 'ports_north_hover '],
      title: 'Ports north Vietnam',
      description: 'Port infrastructure in north Vietnam',
      group: 'infrastructure',
      active: false,
      renderer: (p: ILoaderProps) => <PortsNorth {...p}/>
    }, {
      key: 'ports_central',
      ids: [ 'ports_central', 'ports_central_hover '],
      title: 'Ports central Vietnam',
      description: 'Port infrastructure in central Vietnam',
      group: 'infrastructure',
      active: false,
      renderer: (p: ILoaderProps) => <PortsCentral {...p}/>
    }, {
      key: 'roads_north',
      ids: [ 'roads_north' ],
      title: 'Roads north Vietnam',
      description: 'Road network in north Vietnam',
      group: 'infrastructure',
      active: false,
      renderer: (p: ILoaderProps) => <RoadsNorth {...p}/>
    }, {
      key: 'roads_central',
      ids: [ 'roads_central' ],
      title: 'Roads central Vietnam',
      description: 'Road network in central Vietnam',
      group: 'infrastructure',
      active: false,
      renderer: (p: ILoaderProps) => <RoadsCentral {...p}/>
    },             

    // MODELS GROUP
    {
      key: 'water_quality_north',
      ids: [ 'water_quality_north' ],
      title: 'Water quality north Vietnam',
      description: 'Seaweed aquaculture water quality suitability in north Vietnam',
      group: 'models',
      active: false,
      renderer: (p: ILoaderProps) => <WaterQualityNorth {...p}/>
    }, {
      key: 'water_quality_central',
      ids: [ 'water_quality_central' ],
      title: 'Water quality central Vietnam',
      description: 'Seaweed aquaculture water quality suitability in central Vietnam',
      group: 'models',
      active: false,
      renderer: (p: ILoaderProps) => <WaterQualityCentral {...p}/>
    }, {
      key: 'socioeconomic_north',
      ids: [ 'socioeconomic_north' ],
      title: 'Socioeconomic suitability north Vietnam',
      description: 'Seaweed aquaculture socioeconomic suitability in north Vietnam',
      group: 'models',
      active: false,
      renderer: (p: ILoaderProps) => <SocioeconomicNorth {...p}/>
    }, {
      key: 'socioeconomic_central',
      ids: [ 'socioeconomic_central' ],
      title: 'Socioeconomic suitability central Vietnam',
      description: 'Seaweed aquaculture socioeconomic suitability in central Vietnam',
      group: 'models',
      active: false,
      renderer: (p: ILoaderProps) => <SocioeconomicCentral {...p}/>
    }, {
      key: 'hydrodynamic_north',
      ids: [ 'hydrodynamic_north' ],
      title: 'Hydrodynamic suitability north Vietnam',
      description: 'Seaweed aquaculture hydrodynamic suitability in north Vietnam',
      group: 'models',
      active: false,
      renderer: (p: ILoaderProps) => <HydrodynamicNorth {...p}/>
    }, {
      key: 'hydrodynamic_central',
      ids: [ 'hydrodynamic_central' ],
      title: 'Hydrodynamic suitability central Vietnam',
      description: 'Seaweed aquaculture hydrodynamic suitability in central Vietnam',
      group: 'models',
      active: false,
      renderer: (p: ILoaderProps) => <HydrodynamicCentral {...p}/>
    },      

    



  ],
  datagroups: [
    {
      key: 'atlas',
      title: 'Seaweed aquaculture atlas',
      description: 'Raft and rope seaweed aquaculture suitability in north and central Vietnam',
      exclusive: true,
    }, { 
      key: 'infrastructure',
      title: 'Aquaculture infrastructure',
      description: 'Key value chain assets',
      exclusive: false
    }, {
      key: 'models',
      title: 'Aquaculture atlas models',
      description: 'Raft and rope seaweed aquaculture suitability sub-models',
      exclusive: false
    }
  ],
  dictionary: [
    {
      key: 'suitability',
      text: 'Suitability',
      type: 'suitability'
    }, {
      key: 'ADM1_EN',
      text: 'Province'
    }, {
      key: 'area_km2',
      text: 'Area',
      unit: <>km&sup2;</>,
      type: 'number'
    },
    { key: 'name', text: 'Name' },
    { key: 'type', text: 'Type' },
    { key: 'species', text: 'Species' },
    { key: 'STATION', text: 'Station' },
    { key: 'Temp_C', text: 'Temperature', unit: 'C', type: 'number' },
    { key: 'DO_mgL-1', text: 'Dissolved oxygen', unit: 'mg L-1', type: 'number' },
    { key: 'pH', text: 'pH', type: 'number' },
    { key: 'TDS_mgL-1', text: 'Dissolved solids', unit: 'mg L-1', type: 'number' },    
    { key: 'alk_mgL-1_CaCO3', text: 'Alkalinity', unit: 'mg L-1', type: 'number' },
    { key: 'NH3-N_ugL-1', text: 'Ammonia', unit: 'μg L-1', type: 'number' }
  ]
}

export { Config }
